"use client";

import { useMutation, useQueryClient } from "@tanstack/react-query";

import { customInstance } from "@/lib/api/client";

import { NOTIFICATIONS_KEY } from "./use-notifications";
import { UNREAD_COUNT_KEY } from "./use-unread-count";

/** Marks one notification unread. Distinct from `inbox/hooks/
 *  use-mark-unread.ts` (sequence-scoped threads/chats) — same name,
 *  different domain/endpoints by design (ARBI-851). */
export function useMarkUnread() {
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: (id: string) =>
      customInstance<void>(`/api/notifications/${id}/unread`, {
        method: "POST",
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: NOTIFICATIONS_KEY });
      queryClient.invalidateQueries({ queryKey: UNREAD_COUNT_KEY });
    },
  });

  return {
    ...mutation,
    mutate: (id: string) => mutation.mutate(id),
    mutateAsync: (id: string) => mutation.mutateAsync(id),
  };
}
